export default class ControlPropertyConst
{
	static DISPLAYASPASSWORD = "displayAsPassword";
	 static  IMEENABLE = "imeEnable";
	 static  PASSWORDFIXEDLENGTH = "passwordFixedLength";
	 static  CACHEINPUT = "cacheInput";
	 static  FOCUSINSELECTMODE = "focusInSelectMode";
	 static  SHOWFIELD = "showField";
	
	
	 static  DISPLAYLENGTH = "displayLength";
	 static  NOTNULL = "notNull";

	 static  BACKGROUNDCOLOR = "backgroundColor";
	 static  BACKGROUNDIMAGE = "backgroundImage";
	 static  PADDINGLEFT = "paddingLeft";
	 static  PADDINGRIGHT = "paddingRight";
	 static  PADDINGTOP = "paddingTop";
	 static  PADDINGBOTTOM = "paddingBottom";
	
	 static  HALIGN = "horizontalAlign";
	 static  VALIGN = "verticalAlign";
	
	 static  HASBORDER = "hasBorder";
	 static  BORDERWEIGHT = "borderWeight";
	 static  BORDERCOLOR = "borderColor";
	
	
	
	 static  SIZE = "size";
	 static  SIZEMIN = "sizeMin";
	 static  WIDTH = "width";
	 static  HEIGHT = "height";
	 static  SUFFIX = "suffix";
	 static  WIDTHMIN = "widthMin";
	 static  HEIGHTMIN = "heightMin";
	 static  COMPRESS = "compress";
	
	 static  NUMOFDECIMALS = "numOfDecimals";
	 static  SHOWDECIMALS = "showDecimals";
	
	 static  FLICKTIME = "flickTime";
	
	 static  FONT_SIZE = "fontSize";
	 static  FONT_WEIGHT = "fontWeight";
	 static  FONT_COLOR = "color";
	
	 static  KEYDOWNEVNET = "KeyDownEvent";
	
	 static  ROW_HEIGHT = "rowHeight";
}


// WEBPACK FOOTER //
// ./src/formItem/controlproperty/ControlPropertyConst.js